import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../components/ui/table";

type Security = {
  allotment_date: string;
  allotment_type: string;
  instrument: string;
  total_amount_raised: number;
  number_of_securities_allotted: number;
  nominal_amount_per_security: number;
  premium_amount_per_security: number;
};

type SecuritiesAllotmentProps = {
  securities?: Security[] | null;
  last_updated_date?:string;
};

// Format date function
const formatDate = (dateString: string) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

// Format currency
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 0,
  }).format(amount);
};

const SecuritiesAllotmentSection: React.FC<SecuritiesAllotmentProps> = ({
  securities,last_updated_date
}) => {

  const formatDatein = (d?: string) => {
    if (!d) return "N/A";
  
    const date = new Date(d);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };


  if (!securities || securities.length === 0) {
    return (
      <>
      <div className="flex items-center gap-3 mb-6">
        {/* <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-sm">5</span>
        </div> */}
        <h3 className="text-xl font-bold text-[#9e7926]">Securities Allotment</h3>
      </div>
      <div className="text-gray-500 text-center py-8">
        This company has no recorded securities allotment data.
      </div>
      </>
      
      
    );
  }

  // Optional: Calculate total raised
  const totalRaised = securities.reduce(
    (sum, s) => sum + (s?.total_amount_raised ?? 0),
    0
  );

  return (
    <section className="mb-6">
      <div className="flex items-center gap-3 mb-6">
        {/* <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
          <span className="text-white font-bold text-sm">5</span>
        </div> */}
        <h3 className="text-xl font-bold text-[#9e7926]">Securities Allotment</h3>
        {/* <p>As on .{last_updated_date}</p> */}
      </div>

      <div className="bg-white rounded-lg border shadow-sm overflow-hidden">
        <Table className="break-inside-avoid-page">
          <TableHeader>
            <TableRow className="bg-gray-50">
              <TableHead className="font-semibold text-gray-900">Allotment Date</TableHead>
              <TableHead className="font-semibold text-gray-900">Allotment Type</TableHead>
              <TableHead className="font-semibold text-gray-900">Instrument</TableHead>
              <TableHead className="font-semibold text-gray-900 text-right">Amount</TableHead>
              <TableHead className="font-semibold text-gray-900 text-right">No. of Securities</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {securities.map((security, index) => (
              <TableRow key={index} className="hover:bg-gray-50 transition-colors">
                <TableCell>{formatDatein(security.allotment_date)}</TableCell>
                <TableCell>{security.allotment_type}</TableCell>
                <TableCell>{security.instrument}</TableCell>
                <TableCell className="text-right">
                  {formatCurrency(security.total_amount_raised)}
                </TableCell>
                <TableCell className="text-right">
                  {new Intl.NumberFormat("en-IN").format(
                    security.number_of_securities_allotted
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </section>
  );
};

export default SecuritiesAllotmentSection;
